import { gql } from "@apollo/client";

import { GENERAL_FIELDS, SITE_FIELDS, ARTICLE_FIELDS } from "./shared";
import { ARTICLE_TEASER_IMAGE } from "./articles";

export const AUTHOR_FIELDS = gql`
  fragment AuthorFields on AuthorRecord {
    __typename
    id
    name
    functionTitle
    slug
    slugs: _allSlugLocales {
      locale
      value
    }
    introduction {
      value
    }
    profilePicture {
      id
      responsiveImage(
        imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "400", h: "400", q: "75" }
      ) {
        alt
        height
        src
        title
        width
      }
    }
  }
`;

export const AUTHOR_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${AUTHOR_FIELDS}
  query GetAuthor($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: author(filter: { slug: { eq: $slug } }, locale: $locale) {
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      ...AuthorFields
    }
  }
`;

export const AUTHOR_ARTICLES_QUERY = gql`
  ${ARTICLE_FIELDS}
  ${ARTICLE_TEASER_IMAGE}
  query GetAuthorArticles(
    $authorId: ItemId!
    $locale: SiteLocale!
    $first: IntType = 100
    $skip: IntType = 0
  ) {
    articles: allArticles(
      locale: $locale
      first: $first
      skip: $skip
      filter: { _locales: { allIn: [$locale] }, author: { eq: $authorId } }
      orderBy: date_DESC
    ) {
      ...ArticleFields
      ...ArticleTeaserImage
    }
  }
`;

export const ALL_AUTHOR_SLUGS_QUERY = gql`
  query GetAllAuthorSlugs($locale: SiteLocale!, $first: IntType!, $skip: IntType!) {
    allAuthors(
      locale: $locale
      first: $first
      skip: $skip
      filter: { slug: { neq: null }, _locales: { anyIn: [$locale] } }
    ) {
      __typename
      id
      slugs: _allSlugLocales {
        locale
        value
      }
      seo {
        noIndex
      }
    }
  }
`;
